import {
    LinearProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Tooltip,
    AppBar,
    Typography,
    Toolbar,
    Button,
    Grid,
    Drawer,
    ListItem,
    ListItemText,
    ListItemIcon,
    TextField
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useContext, useEffect, useState, cloneElement } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { FirebaseContext } from '../firebase/context';
import Editor from '../editor/editor.jsx';
import DoneIcon from '@material-ui/icons/Done';
import Welcome from '../steps/welcome/welcome'
import SimpleCss from '../steps/simple-css/simple-css.jsx'
import { useParams, useLocation, useHistory } from 'react-router-dom';
import UniqueCss from '../steps/unique-css/unique-css.jsx'
import XHRDevTools from '../steps/xhr-devtools/xhr-devtools';
import CookieDevTools from '../steps/cookie-devtools/cookie-devtools';
import DataLayerDevTools from '../steps/datalayer-devtools/datalayer-devtools';
import StateCSS from '../steps/state-css/state-css';
import ErrorCSS from '../steps/error-css/error-css';
import DomLoopJS from '../steps/dom-loop-js/dom-loop-js';
import SessionStorageJS from '../steps/session-storage-js/session-storage-js';
import StringsNumbersJS from '../steps/strings-numbers-js/strings-numbers-js';
import HttpJsonJs from '../steps/http-json-js/http-json-js';
import UuidPersistJS from '../steps/uuid-persist-js/uuid-persist-js';
import './home.css'
import AnswerPage from '../answers/answers';

/*/Define each exercise step here. Exercise step must have:
    component: reference to the view that will give the user the instructions and mini - UI for each exercise
    defaultAnswer: If no answer is provided, this will load into the text editor as a starting point
    correctAnswer: This is loaded by the "Answers" page to  make grading easy
    type: code | text - determines if the JS code editor is displayed or a simple text area
    title: the title displayed at the top of the exercise step
    role: se | sa - this determines if the step is visible/optional for the user. the URL will have either /se/ or /sa/ which is used to check the required steps
/*/


let serverDomain = "https://api.quinnandmurray.com";
const path = "/api/exercise/json";

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    serverDomain = "http://localhost:9999";
};


const predefinedSteps = [
    {
        component: <Welcome />,
        defaultAnswer: '// Get the text container\nconst container = document.querySelector("h1");\n\n// Generate a random color code\nconst randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;\n\n//set the container background color to the random color\ncontainer.style.backgroundColor = randomColor;',
        type: 'code',
        title: 'Welcome',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <XHRDevTools />,
        defaultAnswer: '',
        type: 'text',
        title: 'Dev Tools: Network',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <DataLayerDevTools />,
        defaultAnswer: '',
        type: 'text',
        title: 'DevTools: Console',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <CookieDevTools />,
        defaultAnswer: '',
        type: 'text',
        title: 'DevTools: Cookies',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <SimpleCss />,
        defaultAnswer: "/*/\n********INSTRUCTIONS - READ FIRST********\n-Change only the value assigned to the 'selector' variable below\n-Do NOT change anything below the line indicating \"DO NOT CHANGE\"\n-You can click the \"RUN\" button to test your code changes\n/*/\n\n//Change the selector being stored to this variable to complete this step\nconst selector = '.box';\n\n\n\n\n/*/\nDO NOT CHANGE anything below this line\n*******************************************************\n/*/\nconst box = document.querySelector(selector);\nbox.className = box.className + ' spinny';",
        type: 'code',
        resetOnRun: true,
        title: 'CSS: Simple Selectors',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <UniqueCss />,
        defaultAnswer: "/*/\n********INSTRUCTIONS - READ FIRST********\n-Change only the value assigned to the 'selector' variable below\n-Do NOT change anything below the line indicating \"DO NOT CHANGE\"\n-You can click the \"RUN\" button to test your code changes\n/*/\n\n//Change the selector being stored to this variable to complete this step\nconst selector = '.login-button';\n\n\n\n\n\n/*/\nDO NOT CHANGE anything below this line\n**********************************************\n/*/\ndocument.querySelector('#unique-root').addEventListener('click',(e)=>{\n    const match = e.composedPath()?.find(node=>{\n        try{\n            return node.nodeType === 1 && node.matches(selector)\n        }catch(err){\n            console.log(err);\n        }\n    })\n    \n    if(match){\n        console.log('The user clicked the login button!!!')\n    }\n})",
        type: 'code',
        resetOnRun: true,
        title: 'CSS: Unique Selectors',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <StateCSS />,
        defaultAnswer: "/*/\n********INSTRUCTIONS - READ FIRST********\n-Change only the value assigned to the 'selector' variable below\n-Do NOT change anything below the line indicating \"DO NOT CHANGE\"\n-You can click the \"RUN\" button to test your code changes\n/*/\n\n//Change the selector being stored to this variable to complete this step\nconst selector = '.MuiStepContent-root[icon=\"2\"]';\n\n\n\n\n\n/*/\nDO NOT CHANGE anything below this line\n**********************************************\n/*/\nconst step = document.querySelector(selector);\n\n//check if the element that matches the selector is found\nconsole.log('Element was found: ' + !!step);\nconsole.log(step)",
        type: 'code',
        title: 'CSS: Single Page Apps',
        role: ['se', 'sa', 'cse']
    }
    ,
    {
        component: <ErrorCSS />,
        defaultAnswer: "/*/\n********INSTRUCTIONS - READ FIRST********\n-Change only the value assigned to the 'selector' variable below\n-Do NOT change anything below the line indicating \"DO NOT CHANGE\"\n-You can click the \"RUN\" button to test your code changes\n/*/\n\n//Change the selector being stored to this variable to complete this step\nconst selector = '.error-message';\n\n\n\n\n\n/*/\nDO NOT CHANGE anything below this line\n**********************************************\n/*/\nconst step = document.querySelector(selector);\n\n//check if the element that matches the selector is found\nconsole.log('Element was found: ' + !!step);\nconsole.log(step)",
        type: 'code',
        title: 'CSS: Hidden Messages',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <SessionStorageJS />,
        defaultAnswer: "//Write a JS function here to retrieve the cart value from session storage and console log the value.",
        type: 'code',
        title: 'JS: Session Storage',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <StringsNumbersJS />,
        defaultAnswer: "//Write JS here to retrieve the retrieve the cart value, convert it to USD, and console log the result.",
        type: 'code',
        title: 'JS: Strings and Numbers',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <DomLoopJS />,
        defaultAnswer: "//Write a JS function here to retrieve the validation errors, loop through each, and console log the message.",
        type: 'code',
        title: 'JS: DOM and Loops',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <HttpJsonJs />,
        defaultAnswer: "//Modify the handleResponse function below to retrieve and console log just the error message that is returned in the response.\nfunction handleResponse(xhr){\n   console.log(xhr)\n}\n\n/*/\nDon't change anything below this line\n**********************************************\n/*/\n(function() {   \n\tvar xhttp = new XMLHttpRequest(); \n\txhttp.open('GET', \"" + serverDomain + path + "\", true);            \n\n\txhttp.onreadystatechange = function() {            \n\t\tif (this.readyState === 4) {\n\t\t\tvar code = this.status;\n\t\t\ttry{\n\t\t\t     handleResponse(this)\n\t\t\t    \n\t\t\t}catch(err){\n\t\t\t    console.log(err)\n\t\t\t}\n\t\t}\n\t}\n\txhttp.send()    \n}    \n)();    ",
        type: 'code',
        title: 'JS: HTTP & JSON',
        role: ['se', 'sa', 'cse']
    },
    {
        component: <UuidPersistJS />,
        defaultAnswer: "//Write JavaScript code to save the current UUID (window.currentUUID) to an array in localStorage/sessionStorage and console log the array.",
        type: 'code',
        title: 'JS: Persisting Data',
        role: ['se', 'sa', 'cse']
    }
]

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        // marginTop: 64
    },
    appBar: {
    },
    bodyContent: {
        width: `calc(100vw - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
    }
}));

const signOut = (firebase) => {
    firebase.auth().signOut()
}

const HeaderBar = () => {
    const firebase = useContext(FirebaseContext);
    const classes = useStyles();
    const location = useLocation();

    return (
        <AppBar position="static" className={classes.appBar} elevation={0}>
            <Toolbar>
                <Typography variant="h6" className={classes.title}>
                    {location.pathname.indexOf('cse') > -1 ? 'Quantum Metric CSE Technical Exercise' : 'Quantum Metric SE Technical Exercise'}
                </Typography>
                <Button color="secondary" variant="contained" onClick={() => signOut(firebase)}>Sign Out</Button>
            </Toolbar>
        </AppBar>
    )
}

const UserSelect = ({ testTakers, onChange, selectedTaker }) => {
    const persistUser = (user) => {
        window.sessionStorage.setItem('selectedUser', JSON.stringify(user))
    }

    const getUser = (uid) => {
        return testTakers.find(user => user.uid === uid);
    }

    const handleChange = (uid) => {
        const user = getUser(uid);
        persistUser(user);
        onChange(user);
    }

    return (
        <div style={{ width: 500, margin: '0 auto' }}>
            <Autocomplete
                options={testTakers.sort((a, b) => a.last.localeCompare(b.last))}
                getOptionLabel={(option) => {
                    const name = `${option.last}, ${option.first}`
                    const email = option.email;
                    const val = option.last && option.first ? `${name} - ${email}` : email;
                    return val || "";
                }}
                variant='outlined'
                renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                onChange={(e, newValue) => newValue && newValue.uid ? handleChange(newValue.uid) : ''}
                value={selectedTaker ? selectedTaker : ''}
            />
        </div>
        // <Select variant='outlined' onChange={e => handleChange(e.target.value)} value={selectedTaker ? selectedTaker.uid : ''}>
        //     <MenuItem value='none'>Select a test taker</MenuItem>
        //     {testTakers.map((user, i) => {
        //         return <MenuItem key={i} value={user.uid}>{user.email} - {user.first} {user.last}</MenuItem>
        //     })}
        // </Select>
    )
}

const ConfirmationDialog = ({ open, handleClose, handleSubmit, progress }) => {
    return (
        <Dialog
            open={open}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >

            <DialogTitle id="alert-dialog-slide-title">{"Submit your exercise?"}
                {progress ? <LinearProgress /> : ''}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    This will alert your hiring manager that the exercise is finished and ready to be reviewed. Would you like to submit?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} color="primary">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const SubmittedDialog = ({ open, handleClose, title, message }) => {
    return (
        <Dialog
            open={open}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            {/* <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Submit
          </Button>
        </DialogActions> */}
        </Dialog>
    )
}

const SideNav = ({ steps, onListClick, activeStep, showAnswers, firebase, user }) => {
    const history = useHistory();
    const classes = useStyles();
    const params = useParams()
    const [dialogOpen, setDialogOpen] = useState(false);
    const [submitOpen, setSubmitOpen] = useState(false);
    const [submitTitle, setSubmitTitle] = useState("");
    const [submitMessage, setSubmitMessage] = useState("");
    const [progress, setProgress] = useState(false);

    const isOptional = (step) => {
        const role = params.role;
        return step?.role?.indexOf(role) === -1;
    }

    const submitExercise = () => {
        setProgress(true);
        var addMessage = firebase.functions().httpsCallable('sendMail');
        const body = {
            user: {
                first: user.first,
                last: user.last,
                email: user.email,
                role: params.role
            }
        }
        addMessage(body)
            .then((result) => {
                if (result.data.error) {
                    setSubmitTitle("Oops!")
                    setSubmitMessage("Oops! It's looks like there was an error submitting the exercise. Try again, or email your recruiter to let them know you've finished!");
                } else {
                    setSubmitTitle("Thank you!")
                    setSubmitMessage("Your exercise has been submitted!");
                }
                setProgress(false);
                setDialogOpen(false);
                setSubmitOpen(true);
            });
    }

    const disableSubmit = () => {
        const role = params.role;

        const requiredSteps = steps.filter(step => step.role.includes(role))

        const completed = requiredSteps.filter(step => step.complete);


        return requiredSteps.length !== completed.length;
    }

    return (
        <div>
            <Drawer
                className={classes.drawer}
                variant="permanent"
                anchor="left"
                classes={{
                    paper: classes.drawerPaper,
                }}
                key={steps}
            >
                <Tooltip
                    title="All steps must be marked completed"
                    placement="right"
                    disableHoverListener={!disableSubmit()}
                >
                    <div style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Button disabled={disableSubmit()} color="secondary" variant="contained" onClick={() => setDialogOpen(true)}>Submit Exercise</Button>
                    </div>
                </Tooltip>
                {steps.map((item, index) => {

                    //totally hide "optional steps" or steps that are not assigned for the role. Remove this if logic and they will just appear as optional
                    if (!isOptional(item)) {
                        return (
                            <ListItem button key={item.title} onClick={() => { onListClick(index); history.push(`/${params.role || 'se'}/exercise/${index}`) }}>
                                <ListItemText

                                    primary={item.title}
                                    secondary={isOptional(item) ? "optional" : ''}
                                    active={(index === activeStep).toString()}

                                />
                                {item.complete ? <ListItemIcon><DoneIcon /></ListItemIcon> : ''}
                            </ListItem>
                        )
                    } else {
                        return ''
                    }
                })}
                {showAnswers ? <ListItem button key={'answer'} onClick={() => { history.push(`/${params.role || 'se'}/exercise/answers`); onListClick(steps.length) }}>
                    <ListItemText primary={"Answer Summary"} className={(steps.length === activeStep ? 'active' : '') + ' list-text'} />
                </ListItem> : ''}
            </Drawer>
            <ConfirmationDialog progress={progress} open={dialogOpen} handleSubmit={() => submitExercise()} handleClose={() => setDialogOpen(false)} />
            <SubmittedDialog open={submitOpen} handleClose={() => setSubmitOpen(false)} title={submitTitle} message={submitMessage} />
        </div>
    )
}



const Home = () => {
    const [activeStep, setActiveStep] = useState(-1);
    const [activeUser, setActiveUser] = useState('');
    const firebase = useContext(FirebaseContext)
    const [testTakers, setTestTakers] = useState([]); // if the user is an admin, set this array to all people that have taken the test
    const [selectedTaker, setSelectedTaker] = useState(''); // if the user is an admin, set which person's responses they want to review
    const [reset, setReset] = useState(0);
    const [showAnswers, setShowAnswers] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [role, setRole] = useState('se'); // se || sa - defines optional steps

    const history = useHistory();
    const theme = useTheme();
    const params = useParams();
    const location = useLocation();
    const useQuery = new URLSearchParams(location.search)
    const classes = useStyles();

    const [steps, setSteps] = useState(predefinedSteps)



    const getAllUsers = () => {
        const db = firebase.firestore()

        db.collection('users').get().then(querySnapshot => {
            const users = querySnapshot.docs.map(doc => doc.data());
            setTestTakers(users || []);

            //if the URL has a user query param, set the selected user automatically
            if (useQuery.get('user')) {
                setParamUser(useQuery.get('user'), users);
            }
        }).catch(err => console.log(err))
    }

    const setParamUser = (paramUser, users) => {
        const fullUser = users.find(user => user.email === paramUser);
        setSelectedTaker(fullUser)
    }

    const getStatus = () => {
        const db = firebase.firestore()

        //use authStateChanged to wait for firebase to identify if the user is logged in
        firebase.auth().onAuthStateChanged(user => {
            //if there is a user logged in, get their user profile and determine if they are an admin
            if (user) {
                // getAnswerStatus(selectedTaker || user); moving to useEffect to fix race condition with selected taker
                const docRef = db.collection('users').doc(user.uid)
                docRef.get().then(res => {
                    const data = res.data()
                    setActiveUser(data)

                    if (data.isAdmin) {
                        //if this is an admin, get a list of all users that have taken the test and store them in state
                        getAllUsers()
                        setShowAnswers(true);
                        setIsAdmin(true)

                    }
                })
            }
        })
    }

    const updateStepComplete = (completeStatus) => {
        steps[activeStep].complete = completeStatus
        setSteps([...steps])
    }

    const getAnswerStatus = (user) => {
        const db = firebase.firestore()

        if (user) {
            db.collection('answers').where("uid", "==", user.uid).get().then(q => {
                const answers = q.docs.map(doc => Object.assign({ step: doc.id.split("-")[1] }, doc.data()))


                // set all steps complete to false, as this is the default state
                const resetSteps = steps.map(step => {
                    step.complete = false;
                    return step;
                });

                //update the complete state for those marked by the user
                answers.forEach(answer => {
                    resetSteps[answer.step].complete = answer.complete
                })

                //update the steps
                setSteps([...resetSteps]);

            });
        }

    }

    useEffect(() => {

        //get persiste selectted user
        if (window.sessionStorage.getItem('selectedUser')) {
            const selectedUser = window.sessionStorage.getItem('selectedUser');
            if (selectedUser) {
                try {
                    setSelectedTaker(JSON.parse(selectedUser))

                } catch (err) {
                    console.log("Failed to parse selected user")
                }
            }
        }

        //If the user logs out, send back to signin
        firebase.auth().onAuthStateChanged(user => {
            if (!user) {
                history.push(`/${params.role || 'se'}/signin`)
            }
        })

        //set the active exercise step based on the URL exercise id (/exercise/:id)
        //this way if you refresh or navigate to a specific step, it takes you to the correct place
        if (history.location.pathname.indexOf('answers') > -1) {
            setActiveStep(steps.length)

        } else {
            setActiveStep(Number(params.step) || 0)
        }



        //when this page loads, check if the authenticated user is an admin in order to show admin features
        getStatus()
        setRole(params.role || 'se');


    }, [])

    useEffect(() => {
        if (history.location.pathname.indexOf('answers') > -1) {
            document.title = "Answers"

        } else {
            document.title = `Exercise step ${activeStep}`
        }

    }, [activeStep])

    useEffect(() => {
        //when the user or selectedTaker changes, update the answer complete status
        // this needs to be here in order to pick a winner as the active user is set asynchronously and overrides the selected taker
        let desiredUser = !!activeUser && !!activeUser.isAdmin && !!selectedTaker ? selectedTaker : activeUser;
        getAnswerStatus(desiredUser);

    }, [selectedTaker, activeUser])

    return (
        <div>
            <HeaderBar />
            {
                activeUser?.isAdmin ? <div style={{ margin: 10 }}>
                    <UserSelect testTakers={testTakers} onChange={user => { setSelectedTaker(user); }} selectedTaker={selectedTaker} />
                </div> : ''
            }
            <SideNav user={activeUser} firebase={firebase} steps={steps} showAnswers={showAnswers} onListClick={(step) => setActiveStep(step)} activeStep={activeStep} />

            {
                activeStep === steps.length ? <AnswerPage user={selectedTaker && selectedTaker !== 'none' ? selectedTaker : activeUser} steps={steps} classes={classes} /> :
                    <Grid container spacing={0} justify="center" className={classes.bodyContent}>
                        <Grid item xs={6} md={6} style={{ paddingLeft: 32, paddingRight: 32 }}>
                            {reset > -1 && steps[activeStep]?.component ? cloneElement(steps[activeStep]?.component, { key: reset }, null) : ''}
                        </Grid>
                        <Grid item xs={6} md={6}>

                            <Editor
                                isAdmin={isAdmin}
                                reset={reset}
                                activeStep={activeStep}
                                activeUser={activeUser}
                                selectedUser={selectedTaker && selectedTaker !== 'none' ? selectedTaker : activeUser}
                                defaultAnswer={steps[activeStep]?.defaultAnswer}
                                inputType={steps[activeStep]?.type}
                                onRun={() => { if (steps[activeStep]?.resetOnRun) { setReset(reset + 1); console.log(reset) } }}
                                onComplete={(completeStatus) => updateStepComplete(completeStatus)}
                            />

                        </Grid>
                    </Grid>
            }
        </div>
    );
}

export default Home;